<template>
  <div>
    <div class="reservoirbg">
      <div class="reservoir">库区</div>
      <div class="gross">存储总量</div>
      <div class="sum">
        <span class="number" v-for="(item, index) in storage.sum" :key="index">{{item}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    storage: {
      type: Object,
      default: () => {
        return {
        //   reservoir: "库区",
        //   gross: "存储总量",
          sum: "805"
        };
      }
    }
  },
  data() {
    return {};
  }
};
</script>
<style scoped>
.reservoirbg {
  width: 168px;
  height: 155px;
  /* background:#00665E url("../../assets/img/echarts27-1.png") no-repeat; */
  background-color: #00665E;;
  position: relative;
  color: #42beb6;
}
.reservoir {
  width: 100%;
  position: absolute;
  top: 16px;
  line-height: 24px;
  font-weight: 700;
  font-size: 18px;
  text-align: center;
}
.gross {
  position: absolute;
  top: 40px;
  width: 100%;
  text-align: center;
}
.sum {
  width: 100%;
  height: 44px;
  position: absolute;
  top: 82px;
  line-height: 50px;
  font-size: 32px;
}
.number {
  width: 34px;
  display: inline-block;
  /* margin: 10px; */
  text-align: center;
  line-height: 44px;
  font-size: 36px;
  font-weight: 700;
  background: linear-gradient(to top, #09e579, #13b2a0);
  -webkit-background-clip: text;
  color: transparent;
}
span.number:nth-child(1) {
  margin-left: 23px;
}
span.number:nth-child(2) {
  margin-left: 10px;
}
span.number:nth-child(3) {
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts27.vue